// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export { generateProxyInterfaces } from './generate-proxy-interfaces';
export type { GenerateProxyInterfacesOptions, GenerateProxyInterfacesResult } from './generate-proxy-interfaces';
